export default function(checkedNumber, multiplier) {
	return Math.floor((typeof checkedNumber === 'number' ? checkedNumber : checkedNumber.length - 1) / multiplier);
}
